import constants from '@/constants';
import rest from "../../restUtils";
import router from '@/router';


const emptyUser = {
    name: '',
    surname: '',
    patronymic: '',
    email: '',
    role: ''
};

export default {
    namespace: true,
    state: {
        user: Object.assign({}, emptyUser),
        token: '',
        isPhoneFilled: false,
        isContactsFilled: false,
        count: 0
    },

    actions: {
        async authorization({commit, dispatch, getters}, user) {
            try {
                let tokenData = await rest.doPost(
                        `/auth/signin`,
                        {
                            usernameOrEmail: user.username,
                            password: user.password
                        });
                commit('AUTH_SUCCESS', tokenData);
            } catch (error) {
                commit('AUTH_ERROR');
                return error.response.data;
            }
            try {
                await dispatch('loadCurrentUserData');
                dispatch('redirectAfterLogin');
            } catch (error) {
                dispatch('logout');
                router.push({name: 'Index'});
            }
        },

        async authByToken({commit, dispatch}, token) {
            try {
                let tokenData = await rest.doPost(
                        `/auth/signin-by-token?autoAuthToken=${token}`);
                commit('AUTH_SUCCESS', tokenData);
            } catch (error) {
                commit('AUTH_ERROR', {
                    silently: true
                });
                return;
            }
            try {
                await dispatch('loadCurrentUserData');
                dispatch('redirectAfterLogin');
            } catch (error) {
                dispatch('logout');
                router.push({name: 'Index'});
            }
        },

        async registration(context, user) {
            let success;
            try {
                await rest.doPost(
                        `/auth/signup`,
                        {
                            name: user.name,
                            email: user.email,
                            surname: user.surname,
                            patronymic: user.patronymic,
                            password: user.password,
                            language: user.language.toUpperCase()
                        });
                success = true;
            } catch (error) {
                success = false;
            }

            return success;
        },

        async confirmEmail(context, link) {
            let success;
            try {
                await rest.doPost(
                    `/auth/confirmEmail?link=${link}`);
                success = true;
            } catch (error) {
                success = false;
            }
            return success;
        },

        async isAuthenticated({commit, dispatch, getters}) {
            let token = getters.token;
            let authenticated = token && token.length > 0;

            if (!authenticated) {
                let tokenFromStorage = sessionStorage.getItem(constants.SESSION_STORAGE_TOKEN);
                if (tokenFromStorage)
                    authenticated = await dispatch('loadCurrentUserData');
            }

            return !!authenticated;
        },

        async checkPasswordRecoveryLink ({dispatch}, data) {
            let success;
            try {
                await rest.doPost(
                    `/user/password-recovery-link?token=${data.token}&id=${data.id}`);
                success = true;
            } catch (error) {
                success = false;
            }
            return success;
        },

        async loadCurrentUserData({commit}) {
            let success;
            try {
                let userData = await rest.doGet(`/user/current-user`);
                commit('LOAD_USER_DATA', userData);
                commit('UPDATE_USER_CONTACTS_FILLED', userData.addresseeList.length >= 2);
                commit('UPDATE_USER_PHONE_FILLED', userData.phone != null && userData.phone !== '');
                success = true;
            } catch (error) {
                success = false;
            }

            return success;
        },

        async updateUserData({commit}, user) {
            let success;
            try {
                let userData = await rest.doPut(`/user`, user);
                commit('LOAD_USER_DATA', userData);
                commit('UPDATE_USER_PHONE_FILLED', userData.phone != null && userData.phone !== '');
                success = true;
            } catch (error) {
                success = false;
            }

            return success;
        },

        async saveContactList({commit}, contacts) {
            let success;

            try {
                await rest.doPut(`/user/addressee`, contacts);
                commit('UPDATE_USER_CONTACTS_FILLED', contacts.length >= 2);
                success = true;
            } catch (error) {
                success = false;
            }

            return success;
        },

        loadUserContacts() {
            let addresses = rest.doGet(`/user/addressee`);
            return addresses;
        },

        setNewPassword(context, data) {
            return rest.doPost(`/user/new-password`, data);
        },



        refreshPassword(context, data) {
            return rest.doPost(`/user/forgot-password?lang=${data.lang.toUpperCase()}`, data.email);
        },

        changeLanguage(context, lang) {
            return rest.doGet(`/user/change-language?lang=${lang}`);
        },

        setSocialToken({commit}, token) {
            commit('AUTH_SOCIAL_SUCCESS', token);
        },

        async logout({commit, dispatch}) {
            commit('LOGOUT');
        },

        redirectAfterLogin ({context, getters}) {
            let redirectTo = sessionStorage.getItem(constants.SESSION_STORAGE_REDIRECT);
            if (redirectTo && redirectTo.length > 0) {
                sessionStorage.removeItem(constants.SESSION_STORAGE_REDIRECT);
                router.push(redirectTo);
            } else {
                let userRole = getters.currentUser.role;
                if (['ROLE_ADMIN'].includes(userRole)) {
                   router.push({name: 'Clients'});
                } else {
                    router.push({name: 'ClientMails'});
                }
            }
        },

        async updateNotificationsCount({commit}) {
            let success;
            try {
                let count = await rest.doGet(`/admin/notification/count`);
                commit('UPDATE_NOTIFICATIONS_COUNT', count);
                success = true;
            } catch (error) {
                success = false;
            }

            return success;
        }
    },

    mutations: {
        AUTH_SOCIAL_SUCCESS(state, token) {
            state.token = token;
            sessionStorage.setItem(constants.SESSION_STORAGE_TOKEN, token);
        },

        AUTH_SUCCESS(state, user) {
            state.token = user.accessToken;
            state.role = user.role;
            sessionStorage.setItem(constants.SESSION_STORAGE_TOKEN, user.accessToken);
        },

        AUTH_ERROR(state, payload) {
            state.token = '';
            state.user = Object.assign({}, emptyUser);
        },

        LOGOUT(state) {
            state.token = '';
            state.user = Object.assign({}, emptyUser);
            sessionStorage.removeItem(constants.SESSION_STORAGE_TOKEN);
        },

        LOAD_USER_DATA(state, payload) {
            Object.assign(state.user, payload);
        },

        UPDATE_USER_PHONE_FILLED(state, isFilled) {
            state.isPhoneFilled = isFilled
        },

        UPDATE_USER_CONTACTS_FILLED(state, isFilled) {
            state.isContactsFilled = isFilled
        },
        UPDATE_NOTIFICATIONS_COUNT(state, count) {
            state.count = count;
        }
    },

    getters: {
        currentUser: state => state.user,
        token: state => state.token,
        isPhoneFilled: state => state.isPhoneFilled,
        isContactsFilled: state => state.isContactsFilled,
        notificationsCount: state => state.count
    }
};